import axios from "axios";
import {BASE_URL} from "../requests/APIConfig";

export const AddRequest = (params) => {
  const url = `${BASE_URL}/api/YeuCauCapBanSao/ThemMoiYeuCau`;

  return axios.post(url, {
    params: {
      ...params,
    },
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json; charset=utf-8",
      // "Content-Type": "application/json",
    },
  });
};
